import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

// interfaces
import { IPedido } from 'src/app/interfaces/pedido';

// servicios
import { DatosAuxService } from 'src/app/services/datos/datosAux.service';
import { ModalPedidoOrigenService } from 'src/app/services/modal-pedido-origen.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-pedido-origen',
  templateUrl: './modal-pedido-origen.component.html',
  styleUrls: ['./modal-pedido-origen.component.scss']
})
export class ModalPedidoOrigenComponent implements OnInit {
  @Input() pedido?: IPedido = {};

  pedidoOrigenSubscription: Subscription | undefined;
  public dataDir: string = environment.dataDir;

  constructor(
    public modalPedidoOrigenSrv: ModalPedidoOrigenService,
    public datosAuxSrv: DatosAuxService
  ) { }

  ngOnInit(): void {
  }


  ngOnDestroy(): void {
    this.pedidoOrigenSubscription?.unsubscribe();
  }


  cerrarModal() {
    this.modalPedidoOrigenSrv.pedido = undefined;
    this.modalPedidoOrigenSrv.cerrarModal();
  }

  cerrarModalClickOutside(event: MouseEvent) {
    // Cerrar modal al hacer click fuera del modal  
    if ((event.target as HTMLElement).classList.contains('modal')) {
      this.cerrarModal();
    }
  }
}
